





































import anime, { AnimeInstance } from "animejs";
import { Component, Vue } from "vue-property-decorator";
import IConfig from "../typings/IConfig";

/**
 * The attract/home view.
 */
@Component
export default class Home extends Vue {
  private breathAnimation?: AnimeInstance;
  private explodeAnimation?: AnimeInstance;

  private get CONFIG(): IConfig {
    return this.$store.getters.CONFIG;
  }

  /**
   * Handles attract-state touch event.
   */
  private tapHandler() {
    if (!this.breathAnimation) return;
    this.breathAnimation.pause();
    if (this.explodeAnimation) this.explodeAnimation.play();
    anime({
      duration: 5000,
      easing: "easeInOutCubic",
      opacity: 100,
      targets: "#tap-controller"
    });
  }

  private created(): void {
    this.$store.dispatch("resetState");
  }

  private mounted(): void {
    const tapController = document.getElementById(
      "tap-controller"
    ) as HTMLElement;
    tapController.addEventListener("click", this.tapHandler);
    this.breathAnimation = anime({
      direction: "alternate",
      duration: 3000,
      easing: "easeInOutCubic",
      loop: true,
      scale: 1.15,
      targets: ".circle-bg"
    });
    this.explodeAnimation = anime({
      autoplay: false,
      complete: () => {
        if (this.$route.name === "avatar") return;
        this.$router.push("avatar");
      },
      easing: "easeInCubic",
      scale: {
        duration: 1000,
        value: "*=4"
      },
      targets: ".circle-bg"
    });
    const touchPulseAnimation = anime({
      borderWidth: 0,
      delay: anime.stagger(1000),
      duration: 3000,
      easing: "easeInOutCubic",
      loop: true,
      opacity: 0,
      scale: 3,
      targets: ".circle-touch-pulse"
    });
  }

  private beforeDestroy(): void {
    anime.remove("#tap-controller");
    anime.remove(".circle-bg");
    anime.remove(".circle-touch-pulse");
  }
}
